import queryString from "query-string";
import { CREATE_DATA, DELETE_DATA, GET_DATA_LIST, UPDATE_DATA } from "@/api/masterData/fund";

const state = {
  list_data: [],
  mode: "",
};

const mutations = {
  SET_LIST_DATA: (states, payload) => {
    states.list_data = payload;
  },
  SET_MODE: (states, payload) => {
    states.mode = payload;
  },
};

const actions = {
  GET_LIST_DATA: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_DATA_LIST(query);
    const data = resp.data.data;
    commit("SET_LIST_DATA", data);
  },
  CREATE_DATA: ({}, payload) => {
    return CREATE_DATA(payload);
  },
  DELETE_DATA: ({}, payload) => {
    return DELETE_DATA(payload);
  },
  UPDATE_DATA: ({}, payload) => {
    return UPDATE_DATA(payload);
  },
};

const getters = {
  listData: (states) => states.list_data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
